/**
 * GA4 — add_to_cart and begin_checkout event listeners
 *
 * These fire from the storefront, not from the checkout.
 * The purchase event fires server-side via the order-status page.
 */

(function () {
  'use strict';

  // Only run if gtag is loaded
  if (typeof gtag !== 'function') return;

  // -------- add_to_cart --------
  // Intercept all form submissions to /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;

    var fd = new FormData(form);
    var id = fd.get('id') || '';
    var qty = parseInt(fd.get('quantity') || '1', 10);

    // Try to get product info from the form
    var title = form.dataset.productTitle || '';
    var price = parseFloat(form.dataset.productPrice || '0');

    // Defer the event push so the add completes first
    setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var added = cart.items.find(function (i) { return i.variant_id == id; });
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: added ? added.final_line_price / 100 : price * qty,
            items: [{
              item_id: id,
              item_name: added ? added.product_title : title,
              item_variant: added ? added.variant_title : '',
              price: added ? added.price / 100 : price,
              quantity: qty
            }]
          });
        })
        .catch(function () {
          // Fallback: fire without cart lookup
          gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: price * qty,
            items: [{ item_id: id, item_name: title, price: price, quantity: qty }]
          });
        });
    }, 0);
  }, true);

  // -------- begin_checkout --------
  // Intercept clicks on any link or button pointing to /checkout
  document.addEventListener('click', function (e) {
    var el = e.target.closest('a, button');
    if (!el) return;
    var href = el.getAttribute('href') || '';
    var isCheckout =
      href.indexOf('/checkout') !== -1 ||
      (el.name && el.name === 'checkout') ||
      (el.type === 'submit' && (el.name === 'checkout' || el.classList.contains('cart__checkout')));

    if (!isCheckout) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        gtag('event', 'begin_checkout', {
          currency: 'USD',
          value: cart.total_price / 100,
          items: cart.items.map(function (i) {
            return {
              item_id: i.product_id,
              item_name: i.product_title,
              item_variant: i.variant_title,
              price: i.price / 100,
              quantity: i.quantity
            };
          })
        });
      });
  }, true);
})();